// extracted by mini-css-extract-plugin
export default {"speciality-report-container":"Speciality_speciality-report-container__BJm5s"};